import { render } from "./OrderedRulesDetails.vue?vue&type=template&id=14d5fdfb"
import script from "./OrderedRulesDetails.vue?vue&type=script&lang=js"
export * from "./OrderedRulesDetails.vue?vue&type=script&lang=js"

import "./OrderedRulesDetails.vue?vue&type=style&index=0&id=14d5fdfb&lang=scss"

import exportComponent from "D:\\yunchi\\yc\\yc-vue-source\\new-energy\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__